import { maintenanceGuard } from '@examdojo/auth';
import { syllabusUserSubscriptionsResolver, topicsTreeResolver } from '@examdojo/category/v2';
import { AuthGuard } from '@examdojo/user';
import { userSettingsResolver } from '@examdojo/user-settings';
import { RootUrlParts } from '../app.model';
import { allSyllabusesResolver } from '../shared/syllabus.resolver';
import { alreadyOnboardedGuard } from './onboarding.guard';

export const onboardingRoutes = [
  {
    path: RootUrlParts.Onboarding,
    canActivate: [maintenanceGuard, AuthGuard, alreadyOnboardedGuard],
    resolve: {
      syllabuses: allSyllabusesResolver,
      syllabusUserSubscriptions: syllabusUserSubscriptionsResolver,
      topicsTree: topicsTreeResolver,
      userSettings: userSettingsResolver,
    },
    loadComponent: () => import('./onboarding.component').then((m) => m.OnboardingComponent),
  },
];
